import React from "react";
import Card from "../../../components/page/Card";
import Format from "../../../helpers/Format";
import { AppContext } from "../../../contexts/AppContext";
import VerticalTimelineWrapper from "../../../components/timeline/VerticalTimelineWrapper";
import VerticalTimelineItem from "../../../components/timeline/VerticalTimelineItem";
import PropTypes from "prop-types";

function ContasPendentesCard({ dashboardDados }) {
  const { baseUrl } = React.useContext(AppContext);

  return (
    <Card margin={0}>
      <div className="row">
        <div className="col-12">
          <h4 className="mb-4 card-title">Contas a pagar pendentes do mês</h4>
          <VerticalTimelineWrapper>
            {dashboardDados?.contasPendentes ? (
              Object.keys(dashboardDados.contasPendentes).map((chave) => {
                return (
                  <VerticalTimelineItem key={`item-${chave}`}>
                    {chave}
                    {dashboardDados.contasPendentes[chave].map((conta) => {
                      return (
                        <div className="me-3 mt-2 mb-2" key={`conta-${conta}`}>
                          <div className="media">
                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2 mt-1"></i>
                            <div className="media-body mb-1 mt-1">
                              <div>
                                {conta?.descricao} -{" "}
                                {Format.formataValor(conta?.valor ?? 0)}{" "}
                                <a
                                  href={`${baseUrl}contabilidade/contasAPagar/ContasAPagar?tab=${conta?.aba}`}
                                >
                                  Acessar
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </VerticalTimelineItem>
                );
              })
            ) : (
              <VerticalTimelineItem>
                Nenhuma nova notificação
              </VerticalTimelineItem>
            )}
          </VerticalTimelineWrapper>
        </div>
      </div>
    </Card>
  );
}

ContasPendentesCard.propTypes = {
  dashboardDados: PropTypes.object.isRequired,
};

export default ContasPendentesCard;
